"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetFeedbackBenefitBanners = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _contexts = require("../contexts");
var _net = require("../models/graphql-types/net");
var _queriesNet = require("../queries-net");
/**
 * Hook for getting feedback fetching banner data
 */
const useGetFeedbackBenefitBanners = () => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    type
  } = (0, _contexts.useFeedbackBenefitDialog)();
  const {
    data: fetchedData,
    error
  } = (0, _fetching.useGraphqlQuery)({
    query: _queriesNet.feedbackBenefitBanners,
    url: graphQlNetUrl,
    headers,
    variables: {
      type: type ?? _net.FeedbackBenefitBannerType.Cashback
    },
    skip: type == null || loadingHeaders,
    swrConfig: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  const loading = !fetchedData && !error;
  const [data] = fetchedData?.application?.feedbackBenefitBanners ?? [];
  return {
    data,
    loading
  };
};
exports.useGetFeedbackBenefitBanners = useGetFeedbackBenefitBanners;
